const MY_ACCOUNTS = {
  LOAD: 'MY_ACCOUNTS_LOAD',
  LOAD_SUCCESS: 'MY_ACCOUNTS_LOAD_SUCCESS',
  LOAD_FAIL: 'MY_ACCOUNTS_LOAD_FAIL',
  UPDATE_STATE: 'MY_ACCOUNTS_UPDATE_STATE',
  ADD_NEW_ACCOUNT: 'ADD_NEW_ACCOUNT',
  RESET_ACOUNT: 'RESET_ACCOUNT',
  UPDATE_FILTERS_STATE: 'UPDATE_FILTERS_STATE',
  RESET_SELECTED_ACCOUNTS: 'MY_ACCOUNTS_RESET_SELECTED_ACCOUNTS',
  UPDATE_PREVIOUS_FILTERS_STATE: 'UPDATE_PREVIOUS_FILTERS_STATE',
  SET_SELECT_ALL: 'MY_ACCOUNTS_SET_SELECT_ALL',
  UPDATE_LENGTH: 'MY_ACCOUNTS_UPDATE_LENGTH',
  REMOVE_ACCOUNT: 'MY_ACCOUNTS_REMOVE_ACCOUNT',
  ADD_LOAD: 'MY_ACCOUNTS_ADD_LOAD',
  REMOVE_SELECTED_ACCOUNT: 'MY_ACCOUNTS_REMOVE_SELECTED_ACCOUNT',
};

const ADD_ACCOUNT = {
  SUCCESS: 'ADD_ACCOUNT_SUCCESS',
  FAIL: 'ADD_ACCOUNT_FAIL',
};

const ACCOUNTS_NEWS = {
  LOAD: 'ACCOUNTS_NEWS_LOAD',
  LOAD_SUCCESS: 'ACCOUNTS_NEWS_LOAD_SUCCESS',
  LOAD_FAIL: 'ACCOUNTS_NEWS_LOAD_FAIL',
  FILTER_MODE_ON: 'ACCOUNTS_NEWS_FILTER_MODE_ON',
  ADD_CURATE: 'ACCOUNTS_NEWS_ADD_CURATE',
  REMOVE_CURATE: 'ACCOUNTS_NEWS_REMOVE_CURATE',
  ADD_FAVOURITE: 'ACCOUNTS_NEWS_ADD_FAVOURITE',
  REMOVE_FAVOURITE: 'ACCOUNTS_NEWS_REMOVE_FAVOURITE',
  REMOVE_ALL_CURATE: 'ACCOUNTS_NEWS_REMOVE_ALL_CURATE',
  RESET: 'ACCOUNTS_NEWS_LOAD_RESET',
  RESET_DATA: 'ACCOUNTS_NEWS_RESET_DATA',
  LOAD_FILTERS_SUCCESS: 'ACCOUNTS_NEWS_LOAD_FILTERS_SUCCESS',
  PAGE_RESET: 'ACCOUNTS_NEWS_PAGE_RESET',
};

const ACCOUNT_SEARCH = {
  LOAD: 'ACCOUNT_SEARCH_LOAD',
  LOAD_SUCCESS: 'ACCOUNT_SEARCH_LOAD_SUCCESS',
  LOAD_FAIL: 'ACCOUNT_SEARCH_LOAD_FAIL',
  UPDATE_STATE: 'ACCOUNT_SEARCH_UPDATE_STATE',
  UPDATE_SELECTED_STATE: 'UPDATE_SELECTED_STATE',
  ADD_LOAD: 'ACCOUNT_SEARCH_ADD_LOAD',
  RESET_SELECTION: 'ACCOUNT_SEARCH_RESET_SELECTION',
  REMOVE_ACCOUNT: 'ACCOUNT_SEARCH_REMOVE_ACCOUNT',
  RESET_ACCOUNT: 'ACCOUNT_SEARCH_RESET_ACAOUNT',
};

const CURATION_CONTENT = {
  LOAD: 'CURATION_CONTENT_LOAD',
  LOAD_SUCCESS: 'CURATION_CONTENT_LOAD_SUCCESS',
  LOAD_FAIL: 'CURATION_CONTENT_LOAD_FAIL',
};

const CAMPAIGNS_GRAPH_DATA = {
  LOAD: 'CAMPAIGNS_GRAPH_DATA_LOAD',
  LOAD_SUCCESS: 'CAMPAIGNS_GRAPH_DATA_LOAD_SUCCESS',
  LOAD_FAIL: 'CAMPAIGNS_GRAPH_DATA_LOAD_FAIL',
  CLEAR: 'CAMPAIGNS_GRAPH_DATA_CLEAR',
  SET_DATES: 'CAMPAIGNS_GRAPH_DATA_SET_DATES',
  SET_USER: 'CAMPAIGNS_GRAPH_DATA_SET_USER',
};

const ASSETS_GRAPH_DATA = {
  LOAD: 'ASSETS_GRAPH_DATA_LOAD',
  LOAD_SUCCESS: 'ASSETS_GRAPH_DATA_LOAD_SUCCESS',
  LOAD_FAIL: 'ASSETS_GRAPH_DATA_LOAD_FAIL',
  SET_DATES: 'ASSETS_GRAPH_DATA_SET_DATES',
  SET_USER: 'ASSETS_GRAPH_DATA_SET_USER',
  CLEAR: 'ASSETS_GRAPH_DATA_CLEAR',
};
const VERSIONS_GRAPH_DATA = {
  LOAD: 'VERSIONS_GRAPH_DATA_LOAD',
  LOAD_SUCCESS: 'VERSIONS_GRAPH_DATA_LOAD_SUCCESS',
  LOAD_FAIL: 'VERSIONS_GRAPH_DATA_LOAD_FAIL',
  CLEAR: 'VERSIONS_GRAPH_DATA_CLEAR',
};

const CAMPAIGN_DATA_FOR_ASSET = {
  LOAD: 'CAMPAIGN_DATA_FOR_ASSET_LOAD',
  LOAD_SUCCESS: 'CAMPAIGN_DATA_FOR_ASSET_LOAD_SUCCESS',
  LOAD_FAIL: 'CAMPAIGN_DATA_FOR_ASSET_LOAD_FAIL',
  CLEAR: 'CAMPAIGN_DATA_FOR_ASSET_CLEAR',
};

const EMAIL_BROWSER = {
  LOAD: 'EMAIL_BROWSER_LOAD',
  LOAD_SUCCESS: 'EMAIL_BROWSER_LOAD_SUCCESS',
  LOAD_FAIL: 'EMAIL_BROWSER_LOAD_LOAD_FAIL',
  ADD_EMAIL_DATA: 'ADD_EMAIL_DATA',
  RESET: 'EMAIL_BROWSER_LOAD_RESET',
  SEARCH: 'EMAIL_BROWSER_SEARCH',
  SEARCH_SUCCESS: 'EMAIL_BROWSER_SEARCH_SUCCESS',
  SEARCH_FAIL: 'EMAIL_BROWSER_SEARCH_LOAD_FAIL',
  SEARCH_RESET: 'EMAIL_BROWSER_SEARCH_LOAD_RESET',
  SEARCH_RESET_NO_RESULT: 'EMAIL_BROWSER_SEARCH_LOAD_NO_RESULT',
  CHANGE_TOTAL_ASSET_COUNT: 'EMAIL_BROWSER_CHANGE_TOTAL_ASSET_COUNT',
  RESET_COLOR: 'EMAIL_BROWSER_RESET_COLOR',
  SET_COLOR_RED: 'EMAIL_BROWSER_SET_COLOR_RED',
  RESET_EDITIONS_IN_ASSET: 'EMAIL_BROWSER_RESET_EDITIONS_IN_ASSET',
  REMOVE_EMAIL: 'REMOVE_EMAIL',
  SET_EMAIL_NAME: 'SET_EMAIL_NAME',
  REMOVE_EMAILS_OF_CAMPAIGN: 'EMAIL_BROWSER_REMOVE_EMAILS_OF_CAMPAIGN',
};

const EMAIL_BROWSER_EMAILS_IN_CAMPAIGN = {
  LOAD: 'EMAIL_BROWSER_EMAILS_IN_CAMPAIGN_LOAD',
  LOAD_SUCCESS: 'EMAIL_BROWSER_EMAILS_IN_CAMPAIGN_SUCCESS',
  LOAD_FAIL: 'EMAIL_BROWSER_EMAILS_IN_CAMPAIGN_FAIL',
  RESET: 'EMAIL_BROWSER_EMAILS_IN_CAMPAIGN_RESET',
  ADD_CAMPAIGN: 'EMAIL_BROWSER_EMAILS_IN_CAMPAIGN_ADD_CAMPAIGN',
};

const BROWSER_EDITIONS_OF_CAMPAIGN = {
  LOAD: 'BROWSER_EDITIONS_OF_CAMPAIGN_LOAD',
  LOAD_SUCCESS: 'BROWSER_EDITIONS_OF_CAMPAIGN_SUCCESS',
  LOAD_FAIL: 'BROWSER_EDITIONS_OF_CAMPAIGN_FAIL',
  SET_SUBJECT: 'BROWSER_EDITIONS_OF_CAMPAIGN_SET_SUBJECT',
  SET_SINGLE_VERSION: 'BROWSER_EDITIONS_OF_CAMPAIGN_SET_SINGLE_VERSION',
};

const BROWSER_CREATE_ASSET = {
  ADD: 'BROWSER_CREATE_ASSET',
  ADD_SUCCESS: 'BROWSER_CREATE_ASSET_SUCCESS',
  ADD_FAIL: 'BROWSER_CREATE_ASSET_FAIL',
};

const BROWSER_CREATE_ASSET_DRAFT = {
  ADD: 'BROWSER_CREATE_ASSET_DRAFT',
  ADD_SUCCESS: 'BROWSER_CREATE_ASSET_DRAFT_SUCCESS',
  ADD_FAIL: 'BROWSER_CREATE_ASSET_DRAFT_FAIL',
  RESET: 'BROWSER_CREATE_ASSET_DRAFT_RESET',
  RESET_NEWLY_ADDED: 'BROWSER_CREATE_ASSET_DRAFT_RESET_NEWLY_ADDED',
};

const EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL = {
  ADD: 'EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL_ADD',
  ADD_BY_URL: 'EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL_ADD_BY_URL',
  ADD_SUCCESS: 'EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL_SUCCESS',
  ADD_IN_CAMPAIGN_SUCCESS: 'EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL_IN_CAMPAIGN_SUCCESS',
  ADD_FAIL: 'EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL_FAIL',
  RESET: 'EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL_RESET',
  ALREADY_ADDED_OPEN: 'BROSER_ASSET_ALREADY_ADDED_POPUP_OPEN',
  ALREADY_ADDED_CLOSE: 'BROWSER_ASSET_ALREADY_ADDED_POPUP_CLOSE',
  SET_PREVIEW: 'EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL_SET_PREVIEW',
  RESET_RECENT: 'EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL_RESET_RECENT',
  RESET_UNDO: 'EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL_RESET_UNDO',
};

const BROWSER_REMOVE_ASSET_DRAFT = {
  LOAD: 'BROWSER_REMOVE_ASSET_DRAFT_LOAD',
  SUCCESS: 'BROWSER_REMOVE_ASSET_DRAFT_SUCCESS',
  FAIL: 'BROWSER_REMOVE_ASSET_DRAFT_FAIL',
  RESET: 'BROWSER_REMOVE_ASSET_DRAFT_RESET',
};

const EMAIL_BROWSER_ADD_ARTICLES = {
  ADD: 'EMAIL_BROWSER_ADD_ARTICLES_ADD',
  ADD_SUCCESS: 'EMAIL_BROWSER_ADD_ARTICLES_SUCCESS',
  ADD_FAIL: 'EMAIL_BROWSER_ADD_ARTICLES_FAIL',
  RESET: 'EMAIL_BROWSER_ADD_ARTICLES_RESET',
  ALREADY_ADDED_OPEN: 'EMAIL_BROWSER_ADD_ARTICLES_ALREADY_ADDED_OPEN',
  ALREADY_ADDED_CLOSE: 'EMAIL_BROWSER_ADD_ARTICLES_ALREADY_ADDED_CLOSE',
  SET_PREVIEW: 'EMAIL_BROWSER_ADD_ARTICLES_SET_PREVIEW',
  RESET_UNDO: 'EMAIL_BROWSER_ADD_ARTICLES_RESET_UNDO',
};

const EMAIL_BROWSER_CURATION_UNDO = {
  LOAD: 'EMAIL_BROWSER_CURATION_UNDO_LOAD',
  SUCCESS: 'EMAIL_BROWSER_CURATION_UNDO_SUCCESS',
  FAIL: 'EMAIL_BROWSER_CURATION_UNDO_FAIL',
  RESET: 'EMAIL_BROWSER_CURATION_UNDO_RESET',
};

const BROWSER_CREATED_ASSET_DRAFT = {
  ADD: 'BROWSER_CREATED_ASSET_DRAFT',
  ADD_SUCCESS: 'BROWSER_CREATED_ASSET_DRAFT_SUCCESS',
  ADD_FAIL: 'BROWSER_CREATED_ASSET_FAIL',
  RESET: 'BROWSER_CREATED_ASSET_DRAFT_RESET',
};

const WHN_ARTICLES = {
  LOAD: 'WHN_ARTICLES_LOAD',
  LOAD_SUCCESS: 'WHN_ARTICLES_LOAD_SUCCESS',
  LOAD_FAIL: 'WHN_ARTICLES_LOAD_FAIL',
  ADD_CURATE: 'WHN_ARTICLES_ADD_CURATE',
  REMOVE_CURATE: 'WHN_ARTICLES_REMOVE_CURATE',
  ADD_FAVOURITE: 'WHN_ARTICLES_ADD_FAVOURITE',
  REMOVE_FAVOURITE: 'WHN_ARTICLES_REMOVE_FAVOURITE',
  ADD_CHECK: 'WHN_ARTICLES_ADD_CHECK',
  REMOVE_CHECK: 'WHN_ARTICLES_REMOVE_CHECK',
  REMOVE_ALL_CHECK: 'WHN_ARTICLES_REMOVE_ALL_CHECK',
  ORDER_UPDATED: 'WHN_ARTICLES_ORDER_UPDATED',
  UPDATE_CURATED_COUNT: 'WHN_ARTICLES_UPDATE_CURATED_COUNT',
};

const SEARCH_ARTICLES = {
  LOAD: 'SEARCH_ARTICLES_LOAD',
  FIRST_LOAD: 'SEARCH_ARTICLES_FIRST_LOAD',
  LOAD_SUCCESS: 'SEARCH_ARTICLES_LOAD_SUCCESS',
  LOAD_FAIL: 'SEARCH_ARTICLES_LOAD_FAIL',
  ADD_CURATE: 'SEARCH_ARTICLES_ADD_CURATE',
  REMOVE_CURATE: 'SEARCH_ARTICLES_REMOVE_CURATE',
  ADD_FAVOURITE: 'SEARCH_ARTICLES_ADD_FAVOURITE',
  REMOVE_FAVOURITE: 'SEARCH_ARTICLES_REMOVE_FAVOURITE',
  RESET_TOTAL_COUNT: 'SEARCH_ARTICLES_RESET_TOTAL_COUNT',
  UPDATE_NO_DATA_FOR_DAYS_SEARCH: 'SEARCH_ARTICLES_UPDATE_NO_DATA_FOR_DAYS_SEARCH',
  UPDATE_IS_CURATED: 'SEARCH_ARTICLES_UPDATE_IS_CURATED',
  UPDATE_UNDO_IS_CURATED: 'SEARCH_ARTICLES_UPDATE_UNDO_IS_CURATED',
  SOURCE_CONTENT: 'SEARCH_ARTICLES_SOURCE_CONTENT',
  EXCLUDE_CONTENT: 'SEARCH_ARTICLES_EXCLUDE_CONTENT',
  EXCLUDE_KEYWORDS: 'SEARCH_ARTICLES_EXCLUDE_KEYWORDS',
  INCLUDED_KEYWORDS: 'SEARCH_ARTICLES_INCLUDED_KEYWORDS',
  CLEAR_INCLUDED_KEYWORDS: 'SEARCH_ARTICLES_CLEAR_INCLUDED_KEYWORDS',
  RESET_ADVANCED_SEARCH: 'SEARCH_ARTICLES_RESET_ADVANCED_SEARCH',
  ALL_SOURCES_UNCHECKED: 'SEARCH_ARTICLES_ALL_SOURCES_UNCHECKED',
  ADVANCED_SEARCH_RESET_CHECK: 'GLOBAL_ACTION_ADVANCED_SEARCH_RESET_CHECK',
};

const LOGIN = {
  LOAD: 'LOGIN_LOAD',
  LOAD_SUCCESS: 'LOGIN_SUCCESS',
  LOAD_FAIL: 'LOGIN_FAIL',
  TURN_OFF_FIRST_LOGIN: 'LOGIN_TURN_OFF_FIRST_LOGIN',
};

const SIGNUP = {
  LOAD: 'SIGNUP_LOAD',
  LOAD_SUCCESS: 'SIGNUP_SUCCESS',
  LOAD_FAIL: 'SIGNUP_FAIL',
};

const RESET_PASSWORD = {
  LOAD: 'RESET_PASSWORD_LOAD',
  LOAD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  LOAD_FAIL: 'RESET_PASSWORD_FAIL',
};

const DESIGN = {
  LOAD: 'DESIGN_LOAD',
  LOAD_SUCCESS: 'DESIGN_SUCCESS',
  LOAD_FAIL: 'DESIGN_FAIL',
  UPDATE_HTML: 'UPDATE_HTML',
  ENABLE_PREVIEW: 'ENABLE_PREVIEW',
  DISABLE_PREVIEW: 'DISABLE_PREVIEW',
  SET_MISSING_LINK_ERROR: 'DESIGN_SET_MISSING_LINK_ERROR',
  SET_ARTICLES_LIST: 'DESIGN_SET_ARTICLES_LIST',
  SET_ARTICLES_LIST_LOADING: 'DESIGN_SET_ARTICLES_LIST_LOADING',
  RESET_DESIGN: 'DESIGN_RESET_DESIGN',
  DISABLE_PUBLISH: 'DESIGN_DISABLE_PUBLISH',
  ENABLE_PUBLISH: 'DESIGN_ENABLE_PUBLISH',
  EMAIL_NAME_UPDATE: 'DESIGN_EMAIL_NAME_UPDATE',
  RESET: 'DESIGN_RESET',
  SET_DESIGN_UPDATE: 'DESIGN_SET_DESIGN_UPDATE',
  SKELETON_LOAD: 'DESIGN_SKELETON_LOAD',
  SKELETON_LOAD_SUCCESS: 'DESIGN_SKELETON_LOAD_SUCCESS',
  SET_ACTIVE_WORKFLOW_WARNING: 'DESIGN_SET_ACTIVE_WORKFLOW_WARNING',
  SET_GO_TO_PUBLISH_FAIL: 'DESIGN_SET_GO_TO_PUBLISH_FAIL',
  SET_GO_TO_PUBLISH_SUCCESS: 'DESIGN_SET_GO_TO_PUBLISH_SUCCESS',
  SET_GO_TO_PUBLISH_RESET: 'DESIGN_SET_GO_TO_PUBLISH_RESET',
  SET_REGENERATE_LOADING: 'DESIGN_SET_REGENERATE_LOADING',
};

const DESIGN_AUTO_SAVE = {
  LOAD: 'DESIGN_AUTO_SAVE_LOAD',
  SUCCESS: 'DESIGN_AUTO_SAVE_SUCCESS',
  FAIL: 'DESIGN_AUTO_SAVE_FAIL',
};

const GENERATE_PREVIEW = {
  UPDATE: 'GENERATE_UPDATE_PREVIEW',
};

const DESIGN_PREVIEW = {
  LOAD: 'DESIGN_PREVIEW_LOAD',
  LOAD_SUCCESS: 'DESIGN_PREVIEW_SUCCESS',
  LOAD_FAIL: 'DESIGN_PREVIEW_FAIL',
  UPDATE_PREVIEW_TEXT: 'UPDATE_PREVIEW_TEXT',
  ADHOC_RESET: 'ADHOC_RESET',
  RESET: 'DESIGN_PREVIEW_RESET',
  TEMPLATE_CHANGE_ENABLE: 'TEMPLATE_CHANGE_ENABLE',
  TEMPLATE_CHANGE_DISABLE: 'TEMPLATE_CHANGE_DIABLE',
};

const SAVING_DESIGN = {
  LOAD: 'SAVING_DESIGN_LOAD',
  SUCCESS: 'SAVING_DESIGN_SUCCESS',
  FAIL: 'SAVING_DESIGN_FAIL',
  RESET: 'SAVING_DESIGN_RESET',
  LOAD_SUCCESS: 'SAVING_LOAD_SUCCESS',
  SAVE_AS_SUCCESS: 'SAVE_AS_SUCCESS',
  EMAIL_NAME_ALREADY_EXIST: 'EMAIL_NAME_ALREADY_EXIST',
};

const UI_BASED = {
  OPEN_OVERLAY: 'OPEN_OVERLAY',
  CLOSE_OVERLAY: 'CLOSE_OVERLAY',
  OPEN_CURATION_HISTORY: 'OPEN_CURATION_HISTORY',
  CLOSE_CURATION_HISTORY: 'CLOSE_CURATION_HISTORY',
};

const CURATION_HISTORY_SEARCH = {
  LOAD: 'SEARCH_CURATION_LOAD',
  LOAD_SUCCESS: 'SEARCH_CURATION_LOAD_SUCCESS',
  LOAD_FAIL: 'SEARCH_CURATION_LOAD_FAIL',
  EMPTY_SEARCH_RESULTS: 'EMPTY_SEARCH_RESULTS',
  NO_RESULT_FOUND: 'NO_RESULT_FOUND',
  PAGINATION_RESULT_NOTHING_FOUND: 'PAGINATION_RESULT_NOTHING_FOUND',
  DISABLE_NO_RESULT_FOUND: 'DISABLE_NO_RESULT_FOUND',
  ADD_FAVOURITE: 'CURATION_HISTORY_SEARCH_ADD_FAVOURITE',
  REMOVE_FAVOURITE: 'CURATION_HISTORY_SEARCH_REMOVE_FAVOURITE',
};

const CURATION_HISTORY = {
  LOAD: 'CURATION_HISTORY_LOAD',
  LOAD_SUCCESS: 'CURATION_HISTORY_LOAD_SUCCESS',
  LOAD_FAIL: 'CURATION_HISTORY_LOAD_FAIL',
  ADD_CURATE: 'CURATION_HISTORY_ADD_CURATE',
  REMOVE_CURATE: 'CURATION_HISTORY_REMOVE_CURATE',
  ADD_FAVOURITE: 'CURATION_HISTORY_ADD_FAVOURITE',
  REMOVE_FAVOURITE: 'CURATION_HISTORY_REMOVE_FAVOURITE',
  END_OF_LIST: 'CURATION_HISTORY_END_OF_LIST',
};

const FAVORITE_NEWS = {
  LOAD: 'FAVORITE_NEWS_LOAD',
  LOAD_SUCCESS: 'FAVORITE_NEWS_LOAD_SUCCESS',
  LOAD_FAIL: 'FAVORITE_NEWS_LOAD_FAIL',
  ADD_CURATE: 'FAVORITE_NEWS_ADD_CURATE',
  REMOVE_CURATE: 'FAVORITE_NEWS_REMOVE_CURATE',
  REMOVE_ALL_CURATE: 'FAVORITE_NEWS_REMOVE_ALL_CURATE',
  RESET: 'FAVORITE_NEWS_RESET',
};

const CURATION_REMOVE_ARTICLE = {
  LOAD: 'REMOVE_CURATED_ARTICLE_LOAD',
  LOAD_SUCCESS: 'REMOVE_CURATED_ARTICLE_SUCCESS',
  LOAD_FAIL: 'REMOVE_CURATED_ARTICLE_FAIL',
};

// const CURATION_ADD_ARTICLE = {
//   LOAD: "ADD_CURATED_ARTICLE_LOAD",
//   LOAD_SUCCESS: "ADD_CURATED_ARTICLE_SUCCESS",
//   LOAD_FAIL: "ADD_CURATED_ARTICLE_FAIL",
// };

const CLEAR_ALL_CURATION_CONTENT = {
  LOAD: 'CLEAR_ALL_CURATION_CONTENT_LOAD',
  LOAD_SUCCESS: 'CLEAR_ALL_CURATION_CONTENT_LOAD_SUCCESS',
  LOAD_FAIL: 'CLEAR_ALL_CURATION_CONTENT_LOAD_FAIL',
  REMOVE_SINGLE_ARTICLE_LOAD_SUCCESS: 'REMOVE_SINGLE_CURATED_ARTICLE_LOAD_SUCCESS',
};

const ADD_CURATED_CONTENT = {
  ADD: 'ADD_CURATED_CONTENT',
  ADD_SUCCESS: 'ADD_CURATED_CONTENT_SUCCESS',
  ADD_FAIL: 'ADD_CURATED_CONTENT_LOAD_FAIL',
  RESET: 'ADD_CURATED_CONTENT_RESET',
  ALREADY_ADDED: 'ADD_CURATED_CONTENT_ALREADY_ADDED',
};
const PUBLISH = {
  LOAD: 'PUBLISH_LOAD',
  LOAD_SUCCESS: 'PUBLISH_LOAD_SUCCESS',
  LOAD_FAIL: 'PUBLISH_LOAD_FAIL',
  RESET_LOADED: 'RESET_LOADED',
  OPEN: 'PUBLISH_SCREEN_OPEN',
  CLOSE: 'PUBLISH_SCREEN_CLOSE',
  SEND_CONFIRMATION_OPEN: 'PUBLISH_OPEN_SEND_CONFIRMATION',
  SEND_CONFIRMATION_CLOSE: 'PUBLISH_CLOSE_SEND_CONFIRMATION',
  RESET_SHOW_NOT_PREMIUM: 'PUBLISH_RESET_SHOW_NOT_PREMIUM',
  RESET_SENDER_EMAIL: 'PUBLISH_RESET_SENDER_EMAIL',
  OUTLOOK_ROUTE_SUCCESS: 'PUBLISH_OUTLOOK_ROUTE_SUCCESS',
  SET_DEFAULT_SENDER_EMAIL: 'SET_DEFAULT_SENDER_EMAIL',
  RESET_OUTLOOK_ROUTE: 'PUBLISH_RESET_OUTLOOK_ROUTE',
  SHOW_RESEND_MODAL: 'PUBLISH_SHOW_RESEND_MODAL',
};

const PUBLISH_SUBMIT = {
  LOAD: 'PUBLISH_SUBMIT_LOAD',
  SUCCESS: 'PUBLISH_SUBMIT_SUCCESS',
  FAIL: 'PUBLISH_SUBMIT_FAIL',
};

const SAVE_PUBLISH_STATE = {
  LOAD: 'SAVE_PUBLISH_STATE_LOAD',
  SUCCESS: 'SAVE_PUBLISH_STATE_SUCCESS',
  UPDATE: 'SAVE_PUBLISH_STATE_UPDATE',
  FAIL: 'SAVE_PUBLISH_STATE_FAIL',
  FIELD_ERROR: 'SAVE_PUBLISH_STATE_FIELD_ERROR',
};

const SCHEDULE_EMAIL = {
  LOAD: 'SCHEDULE_EMAIL_LOAD',
  SUCCESS: 'SCHEDULE_EMAIL_SUCCESS',
  FAIL: 'SCHEDULE_EMAIL_FAIL',
};

const EMAIL_WITH_OUTLOOK = {
  LOAD: 'EMAIL_WITH_OUTLOOK_LOAD',
  SUCCESS: 'EMAIL_WITH_OUTLOOK_SUCCESS',
  FAIL: 'EMAIL_WITH_OUTLOOK_FAIL',
  SEND_FROM_DISABLE: 'EMAIL_WITH_OUTLOOK_SEND_FROM_DISABLE',
  RESET: 'EMAIL_WITH_OUTLOOK_RESET',
  SET_NEW_WINDOW_STATE: 'EMAIL_WITH_OUTLOOK_SET_NEW_WINDOW_STATE',
  SET_CALLBACK_STATE: 'EMAIL_WITH_OUTLOOK_SET_CALLBACK_STATE',
  RESET_ERROR: 'EMAIL_WITH_OUTLOOK_RESET_ERROR',
};

const PROMO_CODES = {
  LOAD: 'PROMO_CODES_LOAD',
  SUCCESS: 'PROMO_CODES_SUCCESS',
  FAIL: 'PROMO_CODES_FAIL',
  EXPORT_SUCCESS: 'PROMO_CODES_EXPORT_SUCCESS',
};

const USER_ENTITIES = {
  LOAD: 'USER_ENTITIES_LOAD',
  LOAD_SUCCESS: 'USER_ENTITIES_LOAD_SUCCESS',
  LOAD_FAIL: 'USER_ENTITIES_LOAD_FAIL',
  RESET_ENTITIES: 'USER_ENTITIES_RESET_ENTITIES',
};

const ADD_FAVOURITE = {
  LOAD: 'ADD_FAVOURITE_ARTICLE_LOAD',
  LOAD_SUCCESS: 'ADD_FAVOURITE_ARTICLE_SUCCESS',
  LOAD_FAIL: 'ADD_FAVOURITE_ARTICLE_FAIL',
};

const REMOVE_FAVOURITE = {
  LOAD: 'REMOVE_FAVOURITE_ARTICLE_LOAD',
  LOAD_SUCCESS: 'REMOVE_FAVOURITE_ARTICLE_SUCCESS',
  LOAD_FAIL: 'REMOVE_FAVOURITE_ARTICLE_FAIL',
};

const PREVIEW_ARTICLE = {
  LOAD: 'PREVIEW_GET_DATA_ARTICLE_LOAD',
  LOAD_SUCCESS: 'PREVIEW_GET_DATA_ARTICLE_SUCCESS',
  LOAD_FAIL: 'PREVIEW_GET_DATA_ARTICLE_FAIL',
  UPDATE_SEARCH_TERMS: 'PREVIEW_ARTICLE_UPDATE_SEARCH_TERMS',
  RESET_SEARCH_TERMS: 'PREVIEW_ARTICLE_RESET_SEARCH_TERMS',
  RESET: 'PREVIEW_ARTICLE_RESET',
};

const MOST_ENGAGED = {
  LOAD: 'MOST_ENGAGED_LOAD',
  LOAD_SUCCESS: 'MOST_ENGAGED_SUCCESS',
  LOAD_FAIL: 'MOST_ENGAGED_FAIL',
  ADD_CURATE: 'MOST_ENGAGED_ADD_CURATE',
  REMOVE_CURATE: 'MOST_ENGAGED_REMOVE_CURATE',
  ADD_FAVOURITE: 'MOST_ENGAGED_ADD_FAVOURITE',
  REMOVE_FAVOURITE: 'MOST_ENGAGED_REMOVE_FAVOURITE',
  REMOVE_ALL_CURATE: 'MOST_ENGAGED_REMOVE_ALL_CURATE',
};

const GENERATE_RSS = {
  LOAD: 'GENERATE_RSS_FEED_LOAD',
  LOAD_SUCCESS: 'GENERATE_RSS_FEED_SUCCESS',
  LOAD_FAIL: 'GENERATE_RSS_FEED_FAIL',
  RESET: 'GENERATE_RSS_FEED_RESET',
};

const DRAG_DROP = {
  IS_DRAG: 'DRAG_DROP_IS_DRAG',
  DID_DROP_SUCCESS: 'DRAG_DROP_DID_DROP_SUCCESS',
  DID_DROP_FAILURE: 'DRAG_DROP_DID_DROP_FAILURE',
  SET_SELECTED_ID: 'DRAG_DROP_SET_SELECTED_ID',
  REMOVE_SELECTED_ID: 'DRAG_DROP_REMOVE_SELECTED_ID',
  OPEN_ABANDON_POPUP: 'DRAG_DROP_OPEN_ABANDON_POPUP',
  CLOSE_ABANDON_POPUP: 'DRAG_DROP_CLOSE_ABANDON_POPUP',
  SET_IMAGE: 'DRAG_DROP_SET_IMAGE',
  SET_NEWIMAGE: 'DRAG_DROP_SET_NEW_IMAGE',
  SET_CHECK_ARTICLES: 'DRAG_DROP_SET_CHECK_ARTICLES',
  SET_HOVERED_ASSET_ID: 'DRAG_DROP_SET_HOVERED_ASSET_ID',
  GILL_ROY_MOVE_UP: 'DRAG_DROP_SET_GILL_ROY_MOVE_UP',
  GILL_ROY_MOVE_DOWN: 'DRAG_DROP_SET_GILL_ROY_MOVE_DOWN',
  RESET_SELECTED_IDS: 'DRAG_DROP_RESET_SELECTED_IDS',
};

// Following are the actions for the edition page and curation on the edition page
const ALL_ARTICLES_IN_EDITION = {
  SET_EMAIL_ID: 'ALL_ARTICLES_IN_EDITION_SET_EMAIL_ID',
  REORDER: 'ALL_ARTICLES_IN_EDITION_REORDER',
  REMOVE_ALL_ARTICLES: 'ALL_ARTICLES_IN_EDITION_REMOVE_ALL_ARTICLES',
  REMOVE_ARTICLE: 'ALL_ARTICLES_IN_EDITION_REMOVE_ARTICLE',
  RESET_ALL_DATA: 'ALL_ARTICLES_IN_EDITION_RESET_ALL_DATA',
  UPDATE_FOR_HEADER: 'ALL_ARTICLES_IN_EDITION_UPDATE_FOR_HEADER',
  LOAD: 'ALL_ARTICLES_IN_EDITION_LOAD',
  LOAD_SUCCESS: 'ALL_ARTICLES_IN_EDITION_LOAD_SUCCESS',
  LOAD_FAIL: 'ALL_ARTICLES_IN_EDITION_LOAD_FAIL',
  TEMPLATE_ID_UPDATE: 'ALL_ARTICLES_IN_EDITION_TEMPLATE_ID_UPDATE',
  ADD_ARTICLE_BY_FILE_SUCCESS: 'ALL_ARTICLES_IN_EDITION_ADD_ARTICLE_BY_FILE_SUCCESS',
  ARTICLE_ADDED_STATE: 'ALL_ARTICLES_IN_EDITION_ARTICLE_ADDED_STATE',
  ADD_ARTICLE_BY_FILE_LOAD: 'ALL_ARTICLES_IN_EDITION_ADD_ARTICLE_BY_FILE_LOAD',
  ADD_ARTICLE_BY_FILE_FAILED: 'ALL_ARTICLES_IN_EDITION_ADD_ARTICLE_BY_FILE_FAILED',
  RESET_ARTICLE_STATE: 'ALL_ARTICLES_IN_EDITION_RESET_ARTICLE_STATE',
  SUBJECT_UPDATE: 'ALL_ARTICLES_IN_EDITION_SUBJECT_UPDATE',
  ADD_ARTICLE_BY_FILE_ALREADY_ADDED: 'ALL_ARTICLES_IN_EDITION_ADD_ARTICLE_BY_FILE_ALREADY_ADDED',
  RESET: 'ALL_ARTICLES_IN_EDITION_RESET',
  ADD_FAVORTIE_IN_EDITIONS: 'ADD_FAVORTIE_IN_EDITIONS',
  REMOVE_FAVORTIE_IN_EDITIONS: 'REMOVE_FAVORTIE_IN_EDITIONS',
  UPDATE_CURATED_COUNT: 'ALL_ARTICLES_IN_EDITION_UPDATE_CURATED_COUNT',
  UPDATE_ARTICLES_AND_COUNT: 'ALL_ARTICLES_IN_EDITION_UPDATE_ARTICLES_AND_COUNT',
  UPDATE_ARTICLES_ORDER: 'ALL_ARTICLES_IN_EDITION_UPDATE_ARTICLES_ORDER',
  UPDATE_EMAIL_STATUS: 'ALL_ARTICLES_IN_EDITION_UPDATE_EMAIL_STATUS',
  UPDATE_DIGEST: 'ALL_ARTICLES_IN_EDITION_UPDATE_DIGEST',
  ADD_ARTICLE_FROM_FAVORITES: 'ALL_ARTICLES_IN_EDITION_ADD_ARTICLE_FROM_FAVORITES',
  RESET_DATA: 'ALL_ARTICLES_IN_EDITION_RESET_DATA',
  RESET_ALL_EDITION_DATA: 'ALL_ARTICLES_IN_EDITION_RESET_ALL_EDITION_DATA',
  UPDATE_CAMPAIGN_STATE: 'ALL_ARTICLES_IN_EDITION_UPDATE_CAMPAIGN_STATE',
  UPDATE_WORKFLOW_CURRENT_STATE: 'ALL_ARTICLES_IN_EDITION_UPDATE_WORKFLOW_CURRENT_STATE',
  ARTICLES_UPDATED_FLAG: 'ALL_ARTICLES_IN_EDITION_ARTICLES_UPDATED_FLAG',
};

const EMAIL_BROWSER_ADD_EMAIL = {
  ADD: 'EMAIL_BROWSER_ADD_EMAIL_ADD',
  ADD_SUCCESS: 'EMAIL_BROWSER_ADD_EMAIL_ADD_SUCCESS',
  ADD_FAIL: 'EMAIL_BROWSER_ADD_EMAIL_ADD_FAIL',
  RESET: 'EMAIL_BROWSER_ADD_EMAIL_RESET',
  SET_ASSET_NAME: 'SET_ASSET_NAME',
};

const BROWSER_ADD_ASSET_WITH_CAMPAIGN = {
  ADD: 'BROWSER_ADD_ASSET_WITH_CAMPAIGN_ADD',
  ADD_SUCCESS: 'BROWSER_ADD_ASSET_WITH_CAMPAIGN_ADD_SUCCESS',
  ADD_FAIL: 'BROWSER_ADD_ASSET_WITH_CAMPAIGN_ADD_FAIL',
  ADD_ASSET_IN_CAMPAIGN: 'BROWSER_ADD_ASSET_WITH_CAMPAIGN_ASSET_IN_CAMPAIGN',
  ADD_CAMPAIGN: 'BROWSER_ADD_ASSET_WITH_CAMPAIGN_ADD_CAMPAIGN',
};

const CAMPAIGN_AUDIENCE = {
  LISTS_LOAD: 'CAMPAIGN_AUDIENCE_LISTS_LOAD',
  LISTS_SUCCESS: 'CAMPAIGN_AUDIENCE_LISTS_SUCCESS',
  LISTS_FAIL: 'CAMPAIGN_AUDIENCE_LISTS_FAIL',
  CONTACTS_LOAD: 'CAMPAIGN_AUDIENCE_CONTACTS_LOAD',
  CONTACTS_SUCCESS: 'CAMPAIGN_AUDIENCE_CONTACTS_SUCCESS',
  CONTACTS_FAIL: 'CAMPAIGN_AUDIENCE_CONTACTS_FAIL',
  LINK_AUDIENCE_CAMPAIGN_SUCCESS: 'LINK_AUDIENCE_CAMPAIGN_SUCCESS',
  SET_LIST: 'SET_LIST',
  RESET: 'CAMPAIGN_AUDIENCE_RESET',
  SET_EDIT_CONTACT_POPOVER_STATE: 'CAMPAIGN_AUDIENCE_SET_EDIT_CONTACT_POPOVER_STATE',
  SET_LINK_ASIDER_STATE: 'CAMPAIGN_AUDIENCE_SET_LINK_ASIDER_STATE',
};

const AUDIENCE_CONTACT_DETAILS = {
  LOAD: 'AUDIENCE_CONTACT_DETAILS_LOAD,',
  SUCCESS: 'AUDIENCE_CONTACT_DETAILS_SUCCESS,',
  FAIL: 'AUDIENCE_CONTACT_DETAILS_FAIL',
  RESET: 'AUDIENCE_CONTACT_DETAILS_RESET',
};

const AUDIENCE_CONTACT_DASHBOARD = {
  LOAD: 'AUDIENCE_CONTACT_DASHBOARD_LOAD,',
  SUCCESS: 'AUDIENCE_CONTACT_DASHBOARD_SUCCESS,',
  FAIL: 'AUDIENCE_CONTACT_DASHBOARD_FAIL',
};

const AUDIENCE_CONTACT_SUBSCRIPTIONS = {
  LOAD: 'AUDIENCE_CONTACT_SUBSCRIPTIONS_LOAD,',
  SUCCESS: 'AUDIENCE_CONTACT_SUBSCRIPTIONS_SUCCESS,',
  FAIL: 'AUDIENCE_CONTACT_SUBSCRIPTIONS_FAIL',
};

const AUDIENCE_CONTACT_ENGAGEMENT = {
  LOAD: 'AUDIENCE_CONTACT_ENGAGEMENT_LOAD,',
  SUCCESS: 'AUDIENCE_CONTACT_ENGAGEMENT_SUCCESS,',
  FAIL: 'AUDIENCE_CONTACT_ENGAGEMENT_FAIL',
};

const AUDIENCE_CONTACT_SIMILAR = {
  LOAD: 'AUDIENCE_CONTACT_SIMILAR_LOAD,',
  SUCCESS: 'AUDIENCE_CONTACT_SIMILAR_SUCCESS,',
  FAIL: 'AUDIENCE_CONTACT_SIMILAR_FAIL',
};

const ASSET_AUDIENCE = {
  LISTS_LOAD: 'ASSET_AUDIENCE_LISTS_LOAD',
  LISTS_SUCCESS: 'ASSET_AUDIENCE_LISTS_SUCCESS',
  ERROR_SEARCH_TERM: 'ASSET_AUDIENCE_ERROR_SEARCH_TERM',
  ERROR_SEARCH_TERM_LOADING: 'ASSET_AUDIENCE_ERROR_SEARCH_TERM_LOADING',
  LISTS_FAIL: 'ASSET_AUDIENCE_LISTS_FAIL',
  CONTACTS_LOAD: 'ASSET_AUDIENCE_CONTACTS_LOAD',
  CONTACTS_SUCCESS: 'ASSET_AUDIENCE_CONTACTS_SUCCESS',
  CONTACTS_SEARCH_SUCCESS: 'ASSET_AUDIENCE_CONTACTS_SEARCH_SUCCESS',
  RECIPIENT_SEARCH_SUCCESS: 'ASSET_AUDIENCE_RECIPIENT_SEARCH_SUCCESS',
  RECIPIENT_SEARCH_RESET: 'ASSET_AUDIENCE_RECIPIENT_SEARCH_RESET',
  CONTACTS_FAIL: 'ASSET_AUDIENCE_CONTACTS_FAIL',
  LINK_AUDIENCE_ASSET_SUCCESS: 'ASSET_AUDIENCE_LINK_AUDIENCE_ASSET_SUCCESS',
  RESET: 'ASSET_AUDIENCE_RESET',
  CONTACTS_UPDATE_ACTIVE_STATE: 'ASSET_AUDIENCE_CONTACTS_UPDATE_ACTIVE_STATE',
  RESET_SEARCH_CONTACTS: 'ASSET_AUDIENCE_RESET_SEARCH_CONTACTS',
  UPDATE_CONTACT_SUCCESS: 'ASSET_AUDIENCE_UPDATE_CONTACT_SUCCESS',
  REMOVE_CONTACT_SUCCESS: 'ASSET_AUDIENCE_REMOVE_CONTACT_SUCCESS',
  REMOVE_CONTACT_FROM_LIST_SUCCESS: 'ASSET_AUDIENCE_REMOVE_CONTACT_FROM_LIST_SUCCESS',
  LISTS_RECIPIENT_STATE_UPDATE: 'ASSET_AUDIENCE_LISTS_RECIPIENT_STATE_UPDATE',
  CONTACTS_RECIPIENT_STATE_UPDATE: 'ASSET_AUDIENCE_CONTACTS_RECIPIENT_STATE_UPDATE',
  CAMPAIGN_AUDIENCE_ALL_LISTS_DISABLED: 'ASSET_AUDIENCE_ALL_LISTS_DISABLED',
  CAMPAIGN_AUDIENCE_ALL_CONTACTS_DISABLED: 'ASSET_AUDIENCE_ALL_CONTACTS_DISABLED',
  CAMPAIGN_AUDIENCE_LIST_DISABLED: 'ASSET_AUDIENCE_LIST_DISABLED',
  CAMPAIGN_AUDIENCE_CONTACT_DISABLED: 'ASSET_AUDIENCE_CONTACT_DISABLED',
  UNLINK_AUDIENCE_SUCCESS: 'UNLINK_AUDIENCE_ASSET_SUCCESS',
};
const PEOPLE_AUDIENCE = {
  SET_FILTERS: 'PEOPLE_AUDIENCE_SET_FILTERS',
  RESET_CREATE_CONTACT_LOADER: 'PEOPLE_AUDIENCE_RESET_CREATE_CONTACT_LOADER',
  LISTS_LOAD_ALL_PEOPLE: 'PEOPLE_AUDIENCE_LOAD_ALL_PEOPLE',
  LISTS_SUCCESS_ALL_PEOPLE: 'PEOPLE_AUDIENCE_SUCCESS_ALL_PEOPLE',
  LISTS_SUCCESS_ALL_PEOPLE_SEARCH: 'PEOPLE_AUDIENCE_SUCCESS_ALL_PEOPLE_SEARCH',
  ERROR_SEARCH_TERM: 'PEOPLE_AUDIENCE_ERROR_SEARCH_TERM',
  ERROR_SEARCH_TERM_LOADING: 'PEOPLE_AUDIENCE_ERROR_SEARCH_TERM_LOADING',
  LISTS_FAIL_ALL_PEOPLE: 'PEOPLE_AUDIENCE_FAIL_ALL_PEOPLE',
  LISTS_LOAD_ALL_PEOPLE_RESET: 'PEOPLE_AUDIENCE_LISTS_LOAD_ALL_PEOPLE_RESET',
  LISTS_LOAD_PROFILED: 'PEOPLE_AUDIENCE_LOAD_PROFILED',
  LISTS_SUCCESS_PROFILED: 'PEOPLE_AUDIENCE_SUCCESS_PROFILED',
  LISTS_SUCCESS_PROFILED_SEARCH: 'PEOPLE_AUDIENCE_SUCCESS_PROFILED_SEARCH',
  LISTS_FAIL_PROFILED: 'PEOPLE_AUDIENCE_FAIL_PROFILED',
  LISTS_LOAD_UNPROFILED_RESET: 'PEOPLE_AUDIENCE_LISTS_LOAD_UNPROFILED_RESET',
  LISTS_LOAD_UNPROFILED: 'PEOPLE_AUDIENCE_LOAD_UNPROFILED',
  LISTS_SUCCESS_UNPROFILED: 'PEOPLE_AUDIENCE_SUCCESS_UNPROFILED',
  LISTS_SUCCESS_UNPROFILED_SEARCH: 'PEOPLE_AUDIENCE_SUCCESS_UNPROFILED_SEARCH',
  LISTS_FAIL_UNPROFILED: 'PEOPLE_AUDIENCE_FAIL_UNPROFILED',
  CREATE_NEW_CONTACT_LOAD: 'PEOPLE_AUDIENCE_CREATE_NEW_CONTACT_LOAD',
  CREATE_NEW_CONTACT_LOAD_SUCCESS: 'PEOPLE_AUDIENCE_CREATE_NEW_CONTACT_LOAD_SUCCESS',
  CREATE_NEW_CONTACT_UPDATE_SUCCESS: 'PEOPLE_AUDIENCE_CREATE_NEW_CONTACT_UPDATE_SUCCESS',
  CREATE_NEW_CONTACT_LOAD_FAIL: 'PEOPLE_AUDIENCE_CREATE_NEW_CONTACT_LOAD_FAIL',
  CREATE_NEW_CONTACT_RESET_FORM: 'PEOPLE_AUDIENCE_CREATE_NEW_CONTACT_RESET_FORM',
  DELETE_SELECTED_CONTACT_LOAD: 'PEOPLE_AUDIENCE_DELETE_SELECTED_CONTACT_LOAD',
  DELETE_SELECTED_CONTACT_SUCCESS: 'PEOPLE_AUDIENCE_DELETE_SELECTED_CONTACT_SUCCESS',
  DELETE_SELECTED_CONTACT_FAIL: 'PEOPLE_AUDIENCE_DELETE_SELECTED_CONTACT_FAIL',
  DELETE_SELECTED_CONTACT_RESET: 'PEOPLE_AUDIENCE_DELETE_SELECTED_CONTACT_RESET',
  LISTS_REMOVE_UNPROFILED_FROM_PROFILED: 'PEOPLE_AUDIENCE_LISTS_REMOVE_UNPROFILED_FROM_PROFILED',
  LISTS_REMOVE_PROFILED_FROM_UNPROFILED: 'PEOPLE_AUDIENCE_LISTS_REMOVE_PROFILED_FROM_UNPROFILED',
  LISTS_LOAD_PROFILED_RESET: 'PEOPLE_AUDIENCE_LOAD_PROFILED_RESET',
  SET_RELOAD: 'PEOPLE_AUDIENCE_SET_RELOAD',
  UPDATE_CONTACT_SUCCESS: 'PEOPLE_AUDIENCE_UPDATE_CONTACT_SUCCESS',
  UPDATE_CONTACT_CALL_IN_PROGRESS: 'PEOPLE_AUDIENCE_UPDATE_CONTACT_CALL_IN_PROGRESS',
  UPDATE_CONTACT_FAIL: 'PEOPLE_AUDIENCE_UPDATE_CONTACT_FAIL',
  RESET_EDIT_CONTACT: 'PEOPLE_AUDIENCE_RESET_EDIT_CONTACT',
  OPEN_EDIT_CONTACT_SIDEBAR: 'PEOPLE_AUDIENCE_OPEN_EDIT_CONTACT_SIDEBAR',
  CLOSE_EDIT_CONTACT_SIDEBAR: 'PEOPLE_AUDIENCE_CLOSE_EDIT_CONTACT_SIDEBAR',
  SELECTED_PEROSNALITY_TYPES: 'PEOPLE_AUDIENCE_SELECTED_PEROSNALITY_TYPES',
  CREATE_NEW_CONTACT_ADDED_WITH_FILTER_SUCCESS: 'PEOPLE_AUDIENCE_CREATE_NEW_CONTACT_ADDED_WITH_FILTER_SUCCESS',
  TOTAL_COUNT_UPDATE_ON_DELETE_ALL: 'PEOPLE_AUDIENCE_TOTAL_COUNT_UPDATE_ON_DELETE_ALL',
  UPDATE_TOTAL_COUNT_ON_CREATE_CONTACT: 'PEOPLE_AUDIENCE_UPDATE_TOTAL_COUNT_ON_CREATE_CONTACT',
  NEW_CONTACT_CREATED_WITH_FILTERS: 'PEOPLE_AUDIENCE_NEW_CONTACT_CREATED_WITH_FILTERS',
  EXPORT_FILTER_PEOPLE_AUDIENCE: 'PEOPLE_AUDIENCE_EXPORT_FILTER_PEOPLE_AUDIENCE',
  RESET_TOTAL_COUNT: 'PEOPLE_AUDIENCE_RESET_TOTAL_COUNT',
  DELETE_ALL_SELECTED_CONTACT_SUCCESS: 'PEOPLE_AUDIENCE_DELETE_ALL_SELECTED_CONTACT_SUCCESS',
  RESET_CONTACT_UPDATE_FLAG: 'PEOPLE_AUDIENCE_RESET_CONTACT_UPDATE_FLAG',
  UPDATE_CONTACT_EXISTS_IN_LIST_STATE: 'UPDATE_CONTACT_EXISTS_IN_LIST_STATE',
  SET_CURRENT_ACTIVE_LIST: 'SET_CURRENT_ACTIVE_LIST',
  AUDIENCE_FILTER_TOGGLE: 'AUDIENCE_FILTER_TOGGLE',
  ADD_CONTACTS_TO_GLOBAL_LIST: 'ADD_CONTACTS_TO_GLOBAL_LIST',
  NEWLY_ADDED_CONTACT_UPDATE: 'PEOPLE_AUDIENCE_NEWLY_ADDED_CONTACT_UPDATE',
};

const BROWSER_CREATE_ASSET_DRAFT_WITHOUT_CAMPAIGN = {
  ADD: 'BROWSER_CREATE_ASSET_DRAFT_WITHOUT_CAMPAIGN_ADD',
  ADD_SUCCESS: 'BROWSER_CREATE_ASSET_DRAFT_WITHOUT_CAMPAIGN_ADD_SUCCESS',
  ADD_FAIL: 'BROWSER_CREATE_ASSET_DRAFT_WITHOUT_CAMPAIGN_ADD_FAIL',
};

const RECOMMENDED_PEOPLE_SEARCH = {
  LOAD: 'RECOMMENDED_PEOPLE_SEARCH_LOAD',
  SUCCESS: 'RECOMMENDED_PEOPLE_SEARCH_SUCCESS',
  ERROR_SEARCH_TERM: 'RECOMMENDED_PEOPLE_SEARCH_ERROR_SEARCH_TERM',
  ERROR_SEARCH_TERM_LOADING: 'RECOMMENDED_PEOPLE_SEARCH_ERROR_SEARCH_TERM_LOADING',
  FAIL: 'RECOMMENDED_PEOPLE_SEARCH_FAIL',
  CLEAR: 'RECOMMENDED_PEOPLE_SEARCH_CLEAR',
  CLEAR_DATA: 'RECOMMENDED_PEOPLE_SEARCH_CLEAR_DATA',
};

const DYNAMIC_AUDIENCE_MATCHING = {
  LOAD: 'DYNAMIC_AUDIENCE_MATCHING_LOAD',
  SUCCESS: 'DYNAMIC_AUDIENCE_MATCHING_SUCCESS',
  FAIL: 'DYNAMIC_AUDIENCE_MATCHING_FAIL',
  DYNAMIC_KEYWORDS: 'DYNAMIC_AUDIENCE_MATCHING_DYNAMIC_KEYWORDS',
  SEARCH_TERM: 'DYNAMIC_AUDIENCE_MATCHING_SEARCH_TERM',
  DYNAMIC_KEYWORDS_RESET: 'DYNAMIC_AUDIENCE_MATCHING_DYNAMIC_KEYWORDS_RESET',
  ALREADY_SELECTED_CONTACTS: 'DYNAMIC_AUDIENCE_MATCHING_  ALREADY_SELECTED_CONTACTS',
  CLEAR_DATA: 'DYNAMIC_AUDIENCE_MATCHING_CLEAR_DATA',
};

const RECOMMENDED_LIST_SEARCH = {
  LOAD: 'RECOMMENDED_LIST_SEARCH_LOAD',
  SUCCESS: 'RECOMMENDED_LIST_SEARCH_SUCCESS',
  ERROR_SEARCH_TERM: 'RECOMMENDED_LIST_SEARCH_ERROR_SEARCH_TERM',
  ERROR_SEARCH_TERM_LOADING: 'RECOMMENDED_LIST_SEARCH_ERROR_SEARCH_TERM_LOADING',
  FAIL: 'RECOMMENDED_LIST_SEARCH_FAIL',
  CLEAR: 'RECOMMENDED_LIST_SEARCH_CLEAR',
  CLEAR_DATA: 'RECOMMENDED_LIST_SEARCH_CLEAR_DATA',
};

const GET_ALL_ASSETS_IN_CAMPAIGN = {
  LOAD: 'GET_ALL_ASSETS_IN_CAMPAIGN_LOAD',
  LOAD_SUCCESS: 'GET_ALL_ASSETS_IN_CAMPAIGN_LOAD_SUCCESS',
  LOAD_FAIL: 'GET_ALL_ASSETS_IN_CAMPAIGN_LOAD_FAIL',
};

const AUDIENCE_DELETE_CAMPAIGN_CONTACT = {
  LOAD: 'AUDIENCE_DELETE_CAMPAIGN_CONTACT_LOAD',
  SUCCESS: 'AUDIENCE_DELETE_CAMPAIGN_CONTACT_SUCCESS',
  FAIL: 'AUDIENCE_DELETE_CAMPAIGN_CONTACT_FAIL',
};

const AUDIENCE_DELETE_ASSET_CONTACT = {
  LOAD: 'AUDIENCE_DELETE_ASSET_CONTACT_LOAD',
  SUCCESS: 'AUDIENCE_DELETE_ASSET_CONTACT_SUCCESS',
  FAIL: 'AUDIENCE_DELETE_ASSET_CONTACT_FAIL',
};

const AUDIENCE_ADD_LIST_CONTACT = {
  LOAD: 'AUDIENCE_ADD_LIST_CONTACT_LOAD',
  SUCCESS: 'AUDIENCE_ADD_LIST_CONTACT_SUCCESS',
  FAIL: 'AUDIENCE_ADD_LIST_CONTACT_FAIL',
};

const AUDIENCE_REMOVE_RECOMMENDED = {
  CAMPAIGN: 'AUDIENCE_REMOVE_RECOMMENDED_CAMPAIGN',
  ASSET: 'AUDIENCE_REMOVE_RECOMMENDED_ASSET',
  LIST: 'AUDIENCE_REMOVE_RECOMMENDED_LIST',
};

const AUDIENCE_REMOVE_SUBSCRIBED = {
  CAMPAIGN: 'AUDIENCE_REMOVE_SUBSCRIBED_CAMPAIGN',
  ASSET: 'AUDIENCE_REMOVE_SUBSCRIBED_ASSET',
  LIST: 'AUDIENCE_REMOVE_SUBSCRIBED_LIST',
};

const AUDIENCE_PEOPLE = {
  SEARCH: 'AUDIENCE_PEOPLE_SEARCH',
  CLEAR: 'AUDIENCE_PEOPLE_CLEAR',
  RESET: 'AUDIENCE_PEOPLE_RESET',
  ORGANIZATIONS: 'AUDIENCE_PEOPLE_ORGANIZATIONS',
  DESIGNATIONS: 'AUDIENCE_PEOPLE_DESIGNATIONS',
  ORGANIZATIONS_FAIL: 'AUDIENCE_PEOPLE_ORGANIZATIONS_FAIL',
  DESIGNATIONS_FAIL: 'AUDIENCE_PEOPLE_DESIGNATIONS_FAIL',
  LOADING_ORGANIZATIONS: 'AUDIENCE_PEOPLE_LOADING_ORGANIZATIONS',
  LOADING_DESIGNATIONS: 'AUDIENCE_PEOPLE_LOADING_DESIGNATIONS',
  ORGANIZATIONS_UPDATE: 'AUDIENCE_PEOPLE_ORGANIZATIONS_UPDATE',
  DESIGNATIONS_UPDATE: 'AUDIENCE_PEOPLE_DESIGNATIONS_UPDATE',
  ORGANIZATIONS_RESET: 'AUDIENCE_PEOPLE_ORGANIZATIONS_RESET',
  DESIGNATIONS_RESET: 'AUDIENCE_PEOPLE_DESIGNATIONS_RESET',
};

const LIST_IMPORT = {
  LOAD: 'LIST_IMPORT_LOAD',
  SUCCESS: 'LIST_IMPORT_SUCCESS',
  FAIL: 'LIST_IMPORT_FAIL',
  CLOSE: 'LIST_IMPORT_CLOSE',
  PUBLISH_EMAIL_SUCCESS: 'LIST_IMPORT_PUBLISH_EMAIL_SUCCESS',
};

const SUGGESTED_EMAILS = {
  LOAD: 'SUGGESTED_EMAILS_LOAD',
  SUCCESS: 'SUGGESTED_EMAILS_SUCCESS',
  ERROR_SEARCH_TERM: 'ERROR_SEARCH_TERM',
  FAIL: 'SUGGESTED_EMAILS_FAIL',
};

const VIEW_RECIPIENTS = {
  LOAD: 'VIEW_RECIPIENTS_LOAD',
  SUCCESS: 'VIEW_RECIPIENTS_SUCCESS',
  FAIL: 'VIEW_RECIPIENTS_FAIL',
  SET_IS_SEARCH: 'VIEW_RECIPIENTS_SET_IS_SEARCH',
};
const ERROR_PAGES = {
  SET_ERROR: 'SET_ERROR',
  SET_REDIRECT_URL: 'SET_REDIRECT_URL',
  CLEAR_ERROR: 'CLEAR_ERROR',
};
export {
  USER_ENTITIES,
  MY_ACCOUNTS,
  ADD_ACCOUNT,
  WHN_ARTICLES,
  ACCOUNTS_NEWS,
  ACCOUNT_SEARCH,
  SEARCH_ARTICLES,
  LOGIN,
  SIGNUP,
  RESET_PASSWORD,
  CURATION_CONTENT,
  CAMPAIGNS_GRAPH_DATA,
  ASSETS_GRAPH_DATA,
  VERSIONS_GRAPH_DATA,
  CAMPAIGN_DATA_FOR_ASSET,
  UI_BASED,
  DESIGN,
  DESIGN_PREVIEW,
  CURATION_HISTORY_SEARCH,
  CURATION_HISTORY,
  FAVORITE_NEWS,
  CURATION_REMOVE_ARTICLE,
  CLEAR_ALL_CURATION_CONTENT,
  ADD_CURATED_CONTENT,
  PUBLISH,
  ADD_FAVOURITE,
  REMOVE_FAVOURITE,
  PREVIEW_ARTICLE,
  PUBLISH_SUBMIT,
  MOST_ENGAGED,
  GENERATE_RSS,
  DRAG_DROP,
  EMAIL_BROWSER,
  BROWSER_CREATE_ASSET,
  BROWSER_CREATE_ASSET_DRAFT,
  BROWSER_CREATE_ASSET_DRAFT_WITHOUT_CAMPAIGN,
  EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL,
  BROWSER_CREATED_ASSET_DRAFT,
  ALL_ARTICLES_IN_EDITION,
  EMAIL_BROWSER_ADD_EMAIL,
  CAMPAIGN_AUDIENCE,
  EMAIL_BROWSER_ADD_ARTICLES,
  ASSET_AUDIENCE,
  PEOPLE_AUDIENCE,
  AUDIENCE_CONTACT_DETAILS,
  AUDIENCE_CONTACT_DASHBOARD,
  AUDIENCE_CONTACT_SUBSCRIPTIONS,
  RECOMMENDED_PEOPLE_SEARCH,
  RECOMMENDED_LIST_SEARCH,
  EMAIL_BROWSER_EMAILS_IN_CAMPAIGN,
  BROWSER_EDITIONS_OF_CAMPAIGN,
  AUDIENCE_CONTACT_ENGAGEMENT,
  AUDIENCE_CONTACT_SIMILAR,
  BROWSER_ADD_ASSET_WITH_CAMPAIGN,
  GET_ALL_ASSETS_IN_CAMPAIGN,
  AUDIENCE_DELETE_CAMPAIGN_CONTACT,
  AUDIENCE_DELETE_ASSET_CONTACT,
  AUDIENCE_ADD_LIST_CONTACT,
  AUDIENCE_REMOVE_RECOMMENDED,
  AUDIENCE_REMOVE_SUBSCRIBED,
  EMAIL_BROWSER_CURATION_UNDO,
  BROWSER_REMOVE_ASSET_DRAFT,
  LIST_IMPORT,
  SUGGESTED_EMAILS,
  VIEW_RECIPIENTS,
  GENERATE_PREVIEW,
  EMAIL_WITH_OUTLOOK,
  SCHEDULE_EMAIL,
  SAVING_DESIGN,
  SAVE_PUBLISH_STATE,
  AUDIENCE_PEOPLE,
  DYNAMIC_AUDIENCE_MATCHING,
  ERROR_PAGES,
  PROMO_CODES,
};
